import { Button, Heading } from '@sendible/design-system';
import { styled, css } from 'styled-components';

export const Container = styled.header`
  ${({ theme: { colors } }) => css`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    justify-content: space-between;
    padding: 0.5rem 1rem;

    * {
      user-select: none;
    }

    .text {
      flex: 1;
      font-weight: 500;
    }

    .button {
      flex-shrink: 0;

      .spinner {
        fill: ${colors.brandPrimary} !important;

        path {
          stroke: ${colors.brandPrimary} !important;
        }
      }

      &:disabled {
        background: transparent;
        cursor: default;
      }
    }
  `}
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
`;

export const HeadingStyled = styled(Heading)`
  align-self: center;
`;

export const MainHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding: 1.5rem 0;
`;

export const MinimiseButton = styled(Button)<{ rotateIconDegrees: number }>`
  ${({ rotateIconDegrees }) => css`
    svg {
      transform: rotate(${rotateIconDegrees}deg) scaleX(-1);
    }
  `}
`;
